import { GamepadUpIcon } from './GamepadUpIcon';

/**
 * author: GreenTurtwig
 * id 56D5F5A6-18F7-4FA5-8D16-48058EBD98D3
 * name gamepad-up
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-up.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerUpIcon = GamepadUpIcon;
export default ControllerUpIcon